import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const adobeMarketingTemplate = {
	id: 'adobe-marketing',
	guid: '7f8a9c2d-3e4b-5c6a-8d9e-1f2a3b4c5d6e',
	name: 'Adobe Marketing Cloud',
	category: TEMPLATE_CATEGORIES.MARKETING,
	popularity: 'Enterprise',
	color: '#fa0f00',
	icon: 'mdi-adobe',
	description: 'Connect to Adobe Marketing Cloud for integrated marketing solutions.',
	features: ['OAuth2 Auth', 'Profile Management', 'Experience Platform', 'Analytics'],
	configFields: [
		{ name: 'clientId', label: 'Client ID', type: 'text', required: true, placeholder: 'Enter your Adobe client ID' },
		{ name: 'clientSecret', label: 'Client Secret', type: 'password', required: true, placeholder: 'Enter your Adobe client secret' },
		{ name: 'orgId', label: 'Organization ID', type: 'text', required: true, placeholder: 'Enter your Adobe organization ID' },
		{ name: 'technicalAccountId', label: 'Technical Account ID', type: 'text', required: true, placeholder: 'Enter your technical account ID' }
	],
	endpoints: [
		{
			name: 'Create Profile',
			url: 'https://platform.adobe.io/data/core/ups/profile',
			method: 'POST',
			description: 'Create a profile in Adobe Experience Platform',
			cassieObjectID: -3,
			incrementField: 'SyrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' }
			],
			requestBody: '{ "attributes": { "email": "[PLACEHOLDER_EMAIL1]", "firstName": "[PLACEHOLDER_FORENAME]", "lastName": "[PLACEHOLDER_SURNAME]" }}',
			headers: [
				{ Name: 'Authorization', value: 'Bearer [ACCESS_TOKEN]' },
				{ Name: 'x-api-key', value: '[CLIENT_ID]' },
				{ Name: 'x-gw-ims-org-id', value: '[ORG_ID]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Set Preference',
			url: 'https://platform.adobe.io/data/core/ups/profile/preferences',
			method: 'POST',
			description: 'Set user preference or opt-in status',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'ConsentValue', filter: '' }
			],
			requestBody: '{ "email": "[PLACEHOLDER_EMAIL1]", "preferences": { "marketingOptIn": "[PLACEHOLDER_CONSENTVALUE]" }}',
			headers: [
				{ Name: 'Authorization', value: 'Bearer [ACCESS_TOKEN]' },
				{ Name: 'x-api-key', value: '[CLIENT_ID]' },
				{ Name: 'x-gw-ims-org-id', value: '[ORG_ID]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 200, message: 'Preference updated' }]
		}
	],
	defaults: {
		endpointAddress: 'https://platform.adobe.io',
		authenticationTypeId: AUTH_TYPES.JWT,
		frequencyInSeconds: 0,
		notes: 'Adobe Marketing Cloud integration for comprehensive digital marketing and customer experience management.'
	}
}
